import { render, staticRenderFns } from "./ValintatyyppiColumn.vue?vue&type=template&id=3af60922&scoped=true"
import script from "./ValintatyyppiColumn.vue?vue&type=script&lang=js"
export * from "./ValintatyyppiColumn.vue?vue&type=script&lang=js"
import style0 from "./ValintatyyppiColumn.vue?vue&type=style&index=0&id=3af60922&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af60922",
  null
  
)

export default component.exports